export default __webpack_public_path__ + "static/media/gallery_test(1).0d0abedf.png";